/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ManualTreeSearchResult,
  ErrorInfo,
  ManualTreeSearchConditions,
  PostManualTreeSectionAdd200,
  PostManualTreeSectionDelete200,
  PostManualTreeSectionMove200,
  PostManualTreeSectionMoveBody,
  PostManualTreeChapterAdd200,
  PostManualTreeChapterDelete200,
  PostManualTreeChapterMove200,
  PostManualTreeChapterMoveBody,
  PostManualTreeChapterEdit200,
  PostManualTreeChapterEditBody,
  PostManualTreeChapterPagetype200,
  PostManualTreeChapterPagetypeBody,
  ManualTreeExcerptStatus,
  ManualTreeExcerptColorResult
} from '.././model'


/**
 * マニュアルツリーを検索して返す。  
マニュアルの章・セクションをツリー構造で取得する。

 * @summary マニュアルツリー検索
 */
export const postManualTreeSearch = (
    manualTreeSearchConditions: ManualTreeSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ManualTreeSearchResult>> => {
    return axios.post(
      `/manualTree/search`,
      manualTreeSearchConditions,options
    );
  }



    export type PostManualTreeSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeSearch>>>
    export type PostManualTreeSearchMutationBody = ManualTreeSearchConditions
    export type PostManualTreeSearchMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeSearch>>, TError,{data: ManualTreeSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeSearch>>, {data: ManualTreeSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postManualTreeSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeSearch>>, TError, {data: ManualTreeSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L2セクションを章の最下段に追加する

 * @summary L2セクション追加
 */
export const postManualTreeSectionAdd = (
    chapterId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeSectionAdd200>> => {
    return axios.post(
      `/manualTree/sections/${chapterId}/add`,undefined,options
    );
  }



    export type PostManualTreeSectionAddMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeSectionAdd>>>
    
    export type PostManualTreeSectionAddMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeSectionAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeSectionAdd>>, TError,{chapterId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeSectionAdd>>, {chapterId: number}> = (props) => {
          const {chapterId} = props ?? {};

          return  postManualTreeSectionAdd(chapterId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeSectionAdd>>, TError, {chapterId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L2セクションを削除する

 * @summary L2セクション削除
 */
export const postManualTreeSectionDelete = (
    sectionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeSectionDelete200>> => {
    return axios.post(
      `/manualTree/sections/${sectionId}/delete`,undefined,options
    );
  }



    export type PostManualTreeSectionDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeSectionDelete>>>
    
    export type PostManualTreeSectionDeleteMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeSectionDelete = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeSectionDelete>>, TError,{sectionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeSectionDelete>>, {sectionId: number}> = (props) => {
          const {sectionId} = props ?? {};

          return  postManualTreeSectionDelete(sectionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeSectionDelete>>, TError, {sectionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L2セクションを削除する

 * @summary L2セクション削除
 */
export const postManualTreeSectionMove = (
    sectionId: number,
    postManualTreeSectionMoveBody: PostManualTreeSectionMoveBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeSectionMove200>> => {
    return axios.post(
      `/manualTree/sections/${sectionId}/move`,
      postManualTreeSectionMoveBody,options
    );
  }



    export type PostManualTreeSectionMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeSectionMove>>>
    export type PostManualTreeSectionMoveMutationBody = PostManualTreeSectionMoveBody
    export type PostManualTreeSectionMoveMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeSectionMove = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeSectionMove>>, TError,{sectionId: number;data: PostManualTreeSectionMoveBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeSectionMove>>, {sectionId: number;data: PostManualTreeSectionMoveBody}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postManualTreeSectionMove(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeSectionMove>>, TError, {sectionId: number;data: PostManualTreeSectionMoveBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L1セクションを章の最下段に追加する

 * @summary L1セクション追加
 */
export const postManualTreeChapterAdd = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeChapterAdd200>> => {
    return axios.post(
      `/manualTree/chapters/${productionId}/add`,undefined,options
    );
  }



    export type PostManualTreeChapterAddMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeChapterAdd>>>
    
    export type PostManualTreeChapterAddMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeChapterAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeChapterAdd>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeChapterAdd>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postManualTreeChapterAdd(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeChapterAdd>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L1セクションを削除する

 * @summary L1セクション削除
 */
export const postManualTreeChapterDelete = (
    chapterId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeChapterDelete200>> => {
    return axios.post(
      `/manualTree/chapters/${chapterId}/delete`,undefined,options
    );
  }



    export type PostManualTreeChapterDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeChapterDelete>>>
    
    export type PostManualTreeChapterDeleteMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeChapterDelete = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeChapterDelete>>, TError,{chapterId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeChapterDelete>>, {chapterId: number}> = (props) => {
          const {chapterId} = props ?? {};

          return  postManualTreeChapterDelete(chapterId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeChapterDelete>>, TError, {chapterId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L1セクションを削除する

 * @summary L1セクション削除
 */
export const postManualTreeChapterMove = (
    chapterId: number,
    postManualTreeChapterMoveBody: PostManualTreeChapterMoveBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeChapterMove200>> => {
    return axios.post(
      `/manualTree/chapters/${chapterId}/move`,
      postManualTreeChapterMoveBody,options
    );
  }



    export type PostManualTreeChapterMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeChapterMove>>>
    export type PostManualTreeChapterMoveMutationBody = PostManualTreeChapterMoveBody
    export type PostManualTreeChapterMoveMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeChapterMove = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeChapterMove>>, TError,{chapterId: number;data: PostManualTreeChapterMoveBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeChapterMove>>, {chapterId: number;data: PostManualTreeChapterMoveBody}> = (props) => {
          const {chapterId,data} = props ?? {};

          return  postManualTreeChapterMove(chapterId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeChapterMove>>, TError, {chapterId: number;data: PostManualTreeChapterMoveBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L1セクションのタイトルを変更する

 * @summary L1セクションタイトル変更
 */
export const postManualTreeChapterEdit = (
    chapterId: number,
    postManualTreeChapterEditBody: PostManualTreeChapterEditBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeChapterEdit200>> => {
    return axios.post(
      `/manualTree/chapters/${chapterId}/edit`,
      postManualTreeChapterEditBody,options
    );
  }



    export type PostManualTreeChapterEditMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeChapterEdit>>>
    export type PostManualTreeChapterEditMutationBody = PostManualTreeChapterEditBody
    export type PostManualTreeChapterEditMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeChapterEdit = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeChapterEdit>>, TError,{chapterId: number;data: PostManualTreeChapterEditBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeChapterEdit>>, {chapterId: number;data: PostManualTreeChapterEditBody}> = (props) => {
          const {chapterId,data} = props ?? {};

          return  postManualTreeChapterEdit(chapterId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeChapterEdit>>, TError, {chapterId: number;data: PostManualTreeChapterEditBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * L1ページタイプを設定する

 * @summary L1ページタイプ設定
 */
export const postManualTreeChapterPagetype = (
    chapterId: number,
    postManualTreeChapterPagetypeBody: PostManualTreeChapterPagetypeBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostManualTreeChapterPagetype200>> => {
    return axios.post(
      `/manualTree/chapters/${chapterId}/pagetype`,
      postManualTreeChapterPagetypeBody,options
    );
  }



    export type PostManualTreeChapterPagetypeMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeChapterPagetype>>>
    export type PostManualTreeChapterPagetypeMutationBody = PostManualTreeChapterPagetypeBody
    export type PostManualTreeChapterPagetypeMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeChapterPagetype = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeChapterPagetype>>, TError,{chapterId: number;data: PostManualTreeChapterPagetypeBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeChapterPagetype>>, {chapterId: number;data: PostManualTreeChapterPagetypeBody}> = (props) => {
          const {chapterId,data} = props ?? {};

          return  postManualTreeChapterPagetype(chapterId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeChapterPagetype>>, TError, {chapterId: number;data: PostManualTreeChapterPagetypeBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 薄型OM抜粋設定

 * @summary 薄型OM抜粋設定
 */
export const postManualTreeExcerptstatus = (
    productionId: number,
    manualTreeExcerptStatus: ManualTreeExcerptStatus, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/manualTree/${productionId}/excerptstatus`,
      manualTreeExcerptStatus,options
    );
  }



    export type PostManualTreeExcerptstatusMutationResult = NonNullable<Awaited<ReturnType<typeof postManualTreeExcerptstatus>>>
    export type PostManualTreeExcerptstatusMutationBody = ManualTreeExcerptStatus
    export type PostManualTreeExcerptstatusMutationError = AxiosError<ErrorInfo>

    export const usePostManualTreeExcerptstatus = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualTreeExcerptstatus>>, TError,{productionId: number;data: ManualTreeExcerptStatus}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualTreeExcerptstatus>>, {productionId: number;data: ManualTreeExcerptStatus}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postManualTreeExcerptstatus(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualTreeExcerptstatus>>, TError, {productionId: number;data: ManualTreeExcerptStatus}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 薄型OM抜粋ステータス色取得

 * @summary 薄型OM抜粋ステータス色取得
 */
export const getManualTreeExcerptcolor = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ManualTreeExcerptColorResult[]>> => {
    return axios.get(
      `/manualTree/${productionId}/excerptcolor`,options
    );
  }


export const getGetManualTreeExcerptcolorQueryKey = (productionId: number,) => [`/manualTree/${productionId}/excerptcolor`];

    
export type GetManualTreeExcerptcolorQueryResult = NonNullable<Awaited<ReturnType<typeof getManualTreeExcerptcolor>>>
export type GetManualTreeExcerptcolorQueryError = AxiosError<ErrorInfo>

export const useGetManualTreeExcerptcolor = <TData = Awaited<ReturnType<typeof getManualTreeExcerptcolor>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManualTreeExcerptcolor>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetManualTreeExcerptcolorQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getManualTreeExcerptcolor>>> = ({ signal }) => getManualTreeExcerptcolor(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getManualTreeExcerptcolor>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

